import styled from "styled-components";
import { 
  ArrowRight, 
  Euro, 
  ShieldCheck, 
  Zap, 
  ArrowDownRight, 
  ArrowUpRight, 
  ArrowRightLeft, 
  Users 
} from 'lucide-react';
import { LucideIcon } from 'lucide-react';
import * as TypographyStyles from '../TypographyStyles';
import { purpleColors } from '../ContentPages/AppLandingPage/styles';
import { useTranslation } from 'react-i18next';

type TagsProps = {
  tags: string[]
}

type TagConfig = {
  displayName: string;
  icon: LucideIcon;
  color: string;
}

const getTagConfigs = (t: any): Record<string, TagConfig> => ({
  'direct': {
    displayName: t('journeyCard.tags.direct'),
    icon: ArrowRight,
    color: '#6366f1' // indigo
  },
  'cheapest': {
    displayName: t('journeyCard.tags.cheapest'),
    icon: Euro,
    color: '#3b82f6' // blue
  },
  'most-reliable': {
    displayName: t('journeyCard.tags.mostReliable'),
    icon: ShieldCheck,
    color: purpleColors[600] // purple
  },
  'fastest': {
    displayName: t('journeyCard.tags.fastest'),
    icon: Zap,
    color: '#f97316' // orange
  },
  'arrives-first': {
    displayName: t('journeyCard.tags.arrivesFirst'),
    icon: ArrowDownRight,
    color: '#06b6d4' // cyan
  },
  'departs-first': {
    displayName: t('journeyCard.tags.departsFirst'),
    icon: ArrowUpRight,
    color: '#14b8a6' // teal
  },
  'least-transfers': {
    displayName: t('journeyCard.tags.leastTransfers'),
    icon: ArrowRightLeft,
    color: '#6366f1' // indigo
  },
  'least-busy': {
    displayName: t('journeyCard.tags.leastBusy'),
    icon: Users,
    color: '#22c55e' // green
  }
})

const TagsContainer = styled('div')`
  display: flex;
  gap: 0.5rem;
  flex-direction: row;
  justify-content: flex-start;
  margin-bottom: 0.75rem;
  flex-wrap: wrap;
`

export const Tag = styled('div')<{ color: string }>`
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  padding: 0.3rem 0.9rem;
  background-color: ${props => props.color};
  border-radius: 9999px;
  color: white;
  
  svg {
    width: 12px;
    height: 12px;
    flex-shrink: 0;
  }
`

const Tags = ({ tags }: TagsProps) => {
  const { t } = useTranslation();
  const tagConfigs = getTagConfigs(t);
  
  if (!tags || tags.length === 0) return null;
  
  return (
    <TagsContainer>
      {tags.map((tag) => {
        const config = tagConfigs[tag];
        if (!config) return null;
        
        const IconComponent = config.icon;
        return (
          <Tag key={tag} color={config.color}>
            <IconComponent size={12} />
            <TypographyStyles.BodySRegular style={{ fontSize: '12px', fontWeight: 600, color: 'white' }}>
              {config.displayName}
            </TypographyStyles.BodySRegular>
          </Tag>
        );
      })}
  </TagsContainer>
  );
}

export default Tags;